import { Tabs, Tab } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface EventDetailTabsProps {
  useTickets: boolean;
  initialValue: EventTabItem | undefined;
  callback: (item: EventTabItem) => void;
}

export interface EventTabItem {
  label: string;
  key: string;
  value: number;
}

export const tabOptions: EventTabItem[] = [
  {
    label: 'event:information',
    key: 'Information',
    value: 1,
  },
  {
    label: 'event:tickets',
    key: 'Tickets',
    value: 2,
  },
  {
    label: 'event:participants',
    key: 'Participants',
    value: 3,
  },
  {
    label: 'event:formSettings.tab',
    key: 'FormSettings',
    value: 4,
  },
];

const EventDetailTabs = ({ initialValue, callback, useTickets }: EventDetailTabsProps) => {
  const [value, setValue] = React.useState(initialValue ? initialValue.key : 'Information');
  const { t } = useTranslation();

  // TODO: Typa
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleChange = (event: React.ChangeEvent<any>, newValue: string) => {
    setValue(newValue);
    callback(tabOptions.filter((x) => x.key === newValue)[0]);
  };

  const visibleTabs = tabOptions.filter((tab) => useTickets || tab.key !== 'Tickets');

  return (
    <Tabs value={value} textColor='primary' onChange={handleChange} aria-label='event detail tabs'>
      {visibleTabs.map((item) => (
        <Tab key={item.key} label={t(item.label)} value={item.key} />
      ))}
    </Tabs>
  );
};

export default EventDetailTabs;
